import { useCallback, useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import lancamentoNovaService from '../../services/lancamentoNovaService';
import TabelaConciliados from './tabela-conciliados';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import TabelaPendentes from './tabela-pendentes';
import { uniqueId } from 'lodash';


const ModalCard = ({ esteiraID, show, toggleModal, acc, reprocess }: { esteiraID: number, show: boolean, toggleModal: Function, acc: string, reprocess: Function }) => {

    const [loading, setLoading] = useState(false)
    const [types] = useState(['Pendentes', 'Conciliados'])
    const [selected, setSelected] = useState('')
    const [lancamentos, setLancamentos] = useState<any[]>([])
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [loadingButtons, setLoadingButtons] = useState(false);

    const handleSelected = useCallback(async (value) => {
        if (!loading) {
            setLoading(true)
            setSelected(value)
            let result = []

            switch (value) {
                case "Conciliados":
                    result = await lancamentoNovaService.buscarLancamentosExtratoConciliado(esteiraID, acc)
                    break
                case "Pendentes":
                    result = await lancamentoNovaService.buscarLancamentosPendentes(esteiraID, acc)
                    break
                default:
                    break
            }

            setLancamentos(result)
            setLoading(false)
        }
    }, [loading, esteiraID, acc])

    const downloadExcel = useCallback(async () => {
        if (!loadingExcel) {
            setLoadingExcel(true)
            const result = await lancamentoNovaService.gerarArquivoLancamentos(esteiraID, acc)
            console.log(result)
            const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
            const fileExtension = ".xlsx"
            const ws = XLSX.utils.json_to_sheet(result)
            const wb = { Sheets: { data: ws }, SheetNames: ["data"] }
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" })
            const dataF = new Blob([excelBuffer], { type: fileType })
            saveAs(dataF, `Lancamentos-${acc}-${Date.now()}` + fileExtension)
            setLoadingExcel(false)
        }
    }, [loadingExcel, esteiraID, acc])

    const downloadPendenteExcel = useCallback(async () => {
        if (!loadingExcel) {
            setLoadingExcel(true)
            const result = await lancamentoNovaService.gerarArquivoPendentes(esteiraID, acc)
            console.log(result)
            const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
            const fileExtension = ".xlsx"
            const ws = XLSX.utils.json_to_sheet(result.extrato)
            const ws2 = XLSX.utils.json_to_sheet(result.clienteFornecedor)
            const wb = { Sheets: { extrato: ws, clienteFornecedor: ws2 }, SheetNames: ["extrato", "clienteFornecedor"] }
            const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" })
            const dataF = new Blob([excelBuffer], { type: fileType })
            saveAs(dataF, `Pendentes-${acc}-${Date.now()}` + fileExtension)
            setLoadingExcel(false)
        }
    }, [loadingExcel, esteiraID, acc]);

    const Tabela = useCallback(() => {
        switch (selected) {
            case "Conciliados":
                return <TabelaConciliados esteiraID={esteiraID} onUpdateLancamentos={setLancamentos} acc={acc} lancamentos={lancamentos} />
                break
            case "Pendentes":
                return <TabelaPendentes setLancamentos={setLancamentos} esteiraID={esteiraID} acc={acc} lancamentos={lancamentos} />
                break
            default:
                return <></>
                break
        }
    }, [selected, lancamentos, acc, setLancamentos])

    return (
        <Modal size={selected ? 'xl' : 'sm'} centered={true} show={show} scrollable onHide={() => toggleModal()}>
            <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                <div className="modal-header">
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <i onClick={() => toggleModal()} className="fas fa-arrow-left" style={{ color: '#5E6397' }}></i>
                    </div>
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>Detalhes de Lançamentos</h5>
                </div>
                <div className="modal-body" id="scrollableDiv">
                    <div className='row'>
                        {selected && (
                            <div className='col-md-8'>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        {loading ? <label>Estamos carregando os lançamentos...</label> : <Tabela />}
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className={selected ? 'col-md-4' : 'col-md-12'}>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                                        <div onClick={downloadExcel} style={{ width: '100px', flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            {loadingExcel ? (
                                                <label style={{ textAlign: 'center', marginTop: '5px' }}>Carregando</label>
                                            ) : (
                                                <>
                                                    <i className='fa fa-download fs-4 mt-2' style={{ color: 'gray' }} />
                                                    <label style={{ textAlign: 'center', marginTop: '5px' }}>Relatório de Lançamentos</label>
                                                </>
                                            )}
                                        </div>
                                        <div onClick={downloadPendenteExcel} style={{ width: '100px', flexDirection: 'column', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                            {loadingExcel ? (
                                                <label style={{ textAlign: 'center', marginTop: '5px' }}>Carregando</label>
                                            ) : (
                                                <>
                                                    <i className='fa fa-download fs-4 mt-2' style={{ color: 'gray' }} />
                                                    <label style={{ textAlign: 'center', marginTop: '5px' }}>Relatório de Pendentes</label>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                {types.map((item) => (
                                    <div className='col-md-12 mt-2' key={uniqueId()}>
                                        <button onClick={() => handleSelected(item)} style={{ width: '100%', backgroundColor: '#E1E4E9' }} className={selected === item ? 'btn btn-success' : 'btn btn-default'} type='button' key={item}>
                                            {item}
                                        </button>
                                    </div>
                                ))}
                                <div className='col-md-12 mt-2' key={uniqueId()}>
                                    <button onClick={() => reprocess()} style={{ width: '100%', backgroundColor: '#E1E4E9' }} className='btn btn-default' type='button'>
                                        Reprocessar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    )
}

export default ModalCard;